import { TableUrlParams, useTableUrlSync } from '@hooks/useTableUrlSync'
import { Segment } from '@models/Segment'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  getSegments,
  selectSegments,
  setSegmentQuery,
} from '@store/SegmentReducer'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { useSBRM } from '@supplement-bacon/sbrm-react'
import { Flex, Pagination, Row } from 'antd'
import { useEffect } from 'react'
import { SegmentCard } from './Card'

const SegmentCardList = () => {
  const dispatch = useAppDispatch()
  const { isOpen } = useSBRM()
  const segments = useAppSelector(selectSegments())
  const { query, isLoading } = useAppSelector((state) => state.segment)

  const fetchSegments = (params: TableUrlParams) => {
    const newQuery: TableParams = {
      ...query,
      pagination: {
        ...query.pagination,
        current: params.page,
        pageSize: params.pageSize,
      },
    }

    dispatch(setSegmentQuery(newQuery))
    dispatch(getSegments(newQuery))
  }

  const { handleTableChange, params } = useTableUrlSync<Segment>({
    onParamsChange: fetchSegments,
  })

  // Refetch when the SBRM drawer closes: a segment created or edited through it
  // shows up immediately, with the user count the API recomputed.
  useEffect(() => {
    if (isOpen) return

    fetchSegments(params)
  }, [isOpen])

  return (
    <Flex gap={15} vertical>
      {segments
        // `all` is the implicit everyone audience, not a segment.
        .filter((segment) => segment.slug !== 'all')
        .map((segment) => (
          <SegmentCard key={segment.id} model={segment} />
        ))}
      {!isLoading && (query.pagination?.total ?? 0) > 0 && (
        <Row justify="end">
          <Pagination
            current={query.pagination?.current}
            pageSize={query.pagination?.pageSize}
            total={query.pagination?.total}
            onChange={(current, pageSize) =>
              handleTableChange({ current, pageSize }, {}, [])
            }
          />
        </Row>
      )}
    </Flex>
  )
}

type CardListType = { CardList: typeof SegmentCardList }

export { SegmentCardList, type CardListType }
